import { MUI } from 'ci-esi-web-shared';

import { CustomHeaderMenu } from 'app/components/common/CustomHeaderMenu';
import { ProfileMenuBody } from 'app/components/containers/layout/HeaderLandingPage/Profile/ProfileMenu/ProfileMenuBody';

export interface ProfileMenuProps {
  anchorEl: MUI.PopoverProps['anchorEl'];
  onClose: MUI.PopoverProps['onClose'];
}

export function ProfileMenu({ anchorEl, onClose }: ProfileMenuProps) {
  return (
    <CustomHeaderMenu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <ProfileMenuBody onClose={onClose} />
    </CustomHeaderMenu>
  );
}
